<template>
  <table>
    <tr>
      <td>
      </td>
      <td>
        <img @click="clickKey('1')" src="/imgs/klav_1_1.png">
      </td>
      <td>
        <img @click="clickKey('2')" src="/imgs/klav_2_1.png">
      </td>
      <td>
        <img @click="clickKey('3')" src="/imgs/klav_3_1.png">
      </td>
      <td>
        <img @click="clickKey('4')" src="/imgs/klav_4_1.png">
      </td>
      <td>
        <img @click="clickKey('5')" src="/imgs/klav_5_1.png">
      </td>
      <td>
        <img @click="clickKey('6')" src="/imgs/klav_6_1.png">
      </td>
      <td>
        <img @click="clickKey('7')" src="/imgs/klav_7_1.png">
      </td>
      <td>
        <img @click="clickKey('8')" src="/imgs/klav_8_1.png">
      </td>
      <td>
        <img @click="clickKey('9')" src="/imgs/klav_9_1.png">
      </td>
      <td>
        <img @click="clickKey('0')" src="/imgs/klav_0_1.png">
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        <img @click="clickKey('q')" src="/imgs/klav_ru_q_1.png">
      </td>
      <td>
        <img @click="clickKey('w')" src="/imgs/klav_ru_w_1.png">
      </td>
      <td>
        <img @click="clickKey('e')" src="/imgs/klav_ru_e_1.png">
      </td>
      <td>
        <img @click="clickKey('r')" src="/imgs/klav_ru_r_1.png">
      </td>
      <td>
        <img @click="clickKey('t')" src="/imgs/klav_ru_t_1.png">
      </td>
      <td>
        <img @click="clickKey('y')" src="/imgs/klav_ru_y_1.png">
      </td>
      <td>
        <img @click="clickKey('u')" src="/imgs/klav_ru_u_1.png">
      </td>
      <td>
        <img @click="clickKey('i')" src="/imgs/klav_ru_i_1.png">
      </td>
      <td>
        <img @click="clickKey('o')" src="/imgs/klav_ru_o_1.png">
      </td>
      <td>
        <img @click="clickKey('p')" src="/imgs/klav_ru_p_1.png">
      </td>
      <td>
        <img @click="clickKey('[')" src="/imgs/klav_ru_dop1_1.png">
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        <img @click="clickKey('a')" src="/imgs/klav_ru_a_1.png">
      </td>
      <td>
        <img @click="clickKey('s')" src="/imgs/klav_ru_s_1.png">
      </td>
      <td>
        <img @click="clickKey('d')" src="/imgs/klav_ru_d_1.png">
      </td>
      <td>
        <img @click="clickKey('f')" src="/imgs/klav_ru_f_1.png">
      </td>
      <td>
        <img @click="clickKey('g')" src="/imgs/klav_ru_g_1.png">
      </td>
      <td>
        <img @click="clickKey('h')" src="/imgs/klav_ru_h_1.png">
      </td>
      <td>
        <img @click="clickKey('j')" src="/imgs/klav_ru_j_1.png">
      </td>
      <td>
        <img @click="clickKey('k')" src="/imgs/klav_ru_k_1.png">
      </td>
      <td>
        <img @click="clickKey('l')" src="/imgs/klav_ru_l_1.png">
      </td>
      <td>
        <img @click="clickKey(';')" src="/imgs/klav_ru_dop3_1.png">
      </td>
      <td>
        <img @click="clickKey('\'')" src="/imgs/klav_ru_dop4_1.png">
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
        <img @click="clickKey('z')" src="/imgs/klav_ru_z_1.png">
      </td>
      <td>
        <img @click="clickKey('x')" src="/imgs/klav_ru_x_1.png">
      </td>
      <td>
        <img @click="clickKey('c')" src="/imgs/klav_ru_c_1.png">
      </td>
      <td>
        <img @click="clickKey('v')" src="/imgs/klav_ru_v_1.png">
      </td>
      <td>
        <img @click="clickKey('b')" src="/imgs/klav_ru_b_1.png">
      </td>
      <td>
        <img @click="clickKey('n')" src="/imgs/klav_ru_n_1.png">
      </td>
      <td>
        <img @click="clickKey('m')" src="/imgs/klav_ru_m_1.png">
      </td>
      <td>
        <img @click="clickKey(',')" src="/imgs/klav_ru_dop5_1.png">
      </td>
      <td>
        <img @click="clickKey('.')" src="/imgs/klav_ru_dop6_1.png">
      </td>
      <td>
        <img @click="clickKey(']')" src="/imgs/klav_ru_dop2_1.png">
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
    <tr>
      <td>
      </td>
      <td>
      </td>
      <td colspan="8">
        <img @click="clickKey(' ')" src="/imgs/klav_space_1.png">
      </td>
      <td>
      </td>
      <td>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'KeyboardLiteral',
  props: ['onClick'],
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    clickKey(key) {
      const translate = [
        { en: 'q', ru: 'й' },
        { en: 'w', ru: 'ц' },
        { en: 'e', ru: 'у' },
        { en: 'r', ru: 'к' },
        { en: 't', ru: 'е' },
        { en: 'y', ru: 'н' },
        { en: 'u', ru: 'г' },
        { en: 'i', ru: 'ш' },
        { en: 'o', ru: 'щ' },
        { en: 'p', ru: 'з' },
        { en: '[', ru: 'х' },
        { en: ']', ru: 'ъ' },
        { en: 'a', ru: 'ф' },
        { en: 's', ru: 'ы' },
        { en: 'd', ru: 'в' },
        { en: 'f', ru: 'а' },
        { en: 'g', ru: 'п' },
        { en: 'h', ru: 'р' },
        { en: 'j', ru: 'о' },
        { en: 'k', ru: 'л' },
        { en: 'l', ru: 'д' },
        { en: ';', ru: 'ж' },
        { en: '\'', ru: 'э' },
        { en: 'z', ru: 'я' },
        { en: 'x', ru: 'ч' },
        { en: 'c', ru: 'с' },
        { en: 'v', ru: 'м' },
        { en: 'b', ru: 'и' },
        { en: 'n', ru: 'т' },
        { en: 'm', ru: 'ь' },
        { en: ',', ru: 'б' },
        { en: '.', ru: 'ю' },
        { en: ' ', ru: ' ' },
        { en: '1', ru: '1' },
        { en: '2', ru: '2' },
        { en: '3', ru: '3' },
        { en: '4', ru: '4' },
        { en: '5', ru: '5' },
        { en: '6', ru: '6' },
        { en: '7', ru: '7' },
        { en: '8', ru: '8' },
        { en: '9', ru: '9' },
        { en: '0', ru: '0' },
      ];
      this.onClick(translate.find(e => e.en === key).ru.toUpperCase());
    },
  }
}
</script>

<style scoped>

</style>
